import React, { useEffect, useState } from 'react';
import './Loader.css';
import { Spinner } from 'react-bootstrap';
import loaderService from '../../service/loaderService';

const Loader = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = loaderService.subscribe(setLoading);
    return unsubscribe;
  }, []);

  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <Spinner animation="border" variant="light" style={{width:'50px', height: '50px'}}/>
    </div>
  );
};

export default Loader;
